import { useNavigate } from "react-router-dom"
import { Buttom } from "../../components/buttom/buttom"

export const Dashboard = () => {
  const navigate = useNavigate()
  const {username} = JSON.parse(localStorage.getItem("currentUser") as string)
  return (
    <>
      <div className="row m-4 d-flex justify-content-center">
        <h2 id="dashboard-title" className="font-weight-bold text-center">Bem vindo ao sistema de gerenciamento</h2>
      </div>
      <div className="row m-4 d-flex justify-content-center">
        <div className="col-sm-4 m-2 p-0">
          <Buttom text="Ir para Assinaturas" onClick={() => navigate("/assinaturas")} id="nav-link-signature" />
        </div>
        <div className="col-sm-4 m-2 p-0">
          <Buttom text="Ir para Super Usuários" onClick={() => navigate("/super-usuario")}
            id="nav-link-super-user" />

        </div>
        <div className="col-sm-4 m-2 p-0">
          <Buttom text="Estados em Contingência" onClick={() => navigate("/contingencia")}
            id="nav-link-contingency" />
        </div>
        { username !== "adminsuporte" && <div className="col-sm-4 m-2 p-0">
          <Buttom text="Gerenciar Avisos" onClick={() => navigate("/gerenciar-avisos")} id="nav-link-report" />
        </div>}
      </div>
    </>
  )
}